import { Component } from "@angular/core";
import { AuthService } from "app/auth/auth.service";
import {
  AlertController,
  IonicPage,
  LoadingController,
  ModalController,
  NavController,
  NavParams,
  ToastController,
  ViewController,
} from "ionic-angular";
import { AmendedAction } from "models/order-management/amendedAction";
import {
  Action,
  Order,
  OrderComponentPropertyConfiguration,
  OrderTypeConfiguration,
} from "models/order-management/models";
import { OrderPatchRequest } from "models/order-management/orderPatchRequest";
import { OrderResponse } from "models/order-management/orderResponse";
import { StatefulOrderResponse } from "models/order-management/statefullOrderResponse";
import CredentialedResource from "models/resource-management/credentialed-resource";
import * as moment from "moment-timezone";
import { AddNotesPopup } from "pages/order-managment/add-notes/add-notes";
import { UploadOrderDocumentsPopover } from "pages/order-managment/upload-order-documents/upload-order-documents";
import AddEditMARDetails from "pages/orders-entry-om/add-edit-mar-details/add-edit-mar-details";
import { AddOrder } from "pages/orders-entry-om/add-order/add-order";
import CancelOrder, {
  VoidLOCOptions,
} from "pages/orders-entry-om/cancel-order/cancel-order";
import DiscontinueOrder from "pages/orders-entry-om/discontinue-order/discontinue-order";
import ESignOrder from "pages/orders-entry-om/e-sign/e-sign-order";
import EditHospiceCoverage from "pages/orders-entry-om/edit-hospice-coverage/edit-hospice-coverage";
import ReadBackAndVerified from "pages/orders-entry-om/read-back-and-verified/read-back-and-verified";
import {
  MedicationSearchResults,
  PatientMedication,
} from "pages/patient-chart/medications/patient-medication";
import { DocManagementDataService } from "providers/doc-management-data-service/doc-management-data-service";
import { NavBarServiceProvider } from "providers/nav-bar-service/nav-bar-service";
import { OrderManagementDataService } from "providers/order-management-data-service/order-management-data-service";
import { ReportExecutionService } from "providers/report-execution-service/report-execution.service";
import { StateManagementService } from "providers/state-management/state-management.service";
import { Observable } from "rxjs/Observable";
import Utils from "utils/Utilities";
import { CreateCommentModalPage } from "../../../pages/inter-disciplinary-group/create-comment-modal/create-comment-modal";
import RejectOrder from "../../../pages/orders-entry-om/provider-panel/reject-order/reject-order";

@IonicPage()
@Component({
  selector: "page-edit-view-popover",
  templateUrl: "edit-view-popover.html",
})
export class EditViewPopoverPage {
  public editAccess: boolean = true;
  public patientId: number;
  hideDeleteIcon: boolean = false;
  onlyDelete: boolean = false;
  showHistory: boolean = false;
  disabledIcon: boolean = false;
  disabledEdit: boolean = false;
  disabledDelete: boolean = false;
  hideAdd: boolean = false;
  hideEdit: boolean = false;
  hideHistory: boolean = false;
  showButtonsAsList: boolean = false;
  optionMenuNameAmend: string = "Amend Order";
  optionMenuNameEsign: string = "e-Sign";
  optionMenuNameUploadSignatureOrder: string = "Upload Signed Order";
  optionMenuNamePrint: string = "Print";
  addButtonNameInList: string = "Add";
  editButtonNameInList: string = "Edit";
  deleteButtonNameInList: string = "Delete";
  optionMenuNotes: string = "Add an Operational Note";
  accessLevel: number;
  historyLevel: number;
  page: string = "";
  type: string = "";
  isPatientChart: boolean = false;
  isAdministrationEntry: boolean = false;
  isNewCalendar: boolean = false;
  deleteAccess: boolean = false;
  showMarHeaderOptions: boolean = false;
  showPrintMarButton: boolean = false;
  showBenefitsButtonStrip: boolean = false;
  cbMember: boolean = false;
  cbMemberStatus: string = "deactivate";
  hideOrderManagment: boolean = false;
  hideAllOrderManagment: boolean = false;
  showMedicationEdit: boolean = false;
  showOrderManagement: boolean = false;
  isOrder: boolean = false;
  isPalliative: boolean = false;
  isPanelProvider: boolean = false;
  isAlreadySigned: boolean = false;
  listFiles = [];
  idFiles: string[] = [];
  spinnerCounter = 0;
  spinner = null;
  orderPatientChartId = 0;
  order: OrderResponse;
  orderId = 0;
  orderTypeConfigurations: Array<OrderTypeConfiguration> = [];

  marDetailsComponentProperties: Array<OrderComponentPropertyConfiguration> =
    [];
  marDetailsComponentPropertiesIsEmpty: boolean = true;

  orders: Array<StatefulOrderResponse> = [];
  userDisplayName: string;
  orderType: string;
  signatureRequest: Action.SignatureRequestEnum;
  optionMenuNameEditHospiceCoverage: string = "Edit Hospice Coverage";
  optionMenuNameAddEditMARDetails: string = "Add / Edit MAR Details";
  includeAddEditMARDetails: boolean = false;

  optionMenuNameVoid = "Void";
  disableCancelLOC = false;
  locOrders: StatefulOrderResponse[] = null;
  discontinuedLocOrders: StatefulOrderResponse[] = [];
  medicationSearchResults: MedicationSearchResults;
  orderingProviderId = 0;
  credentialedResource: CredentialedResource;

  medication: PatientMedication;
  amendableOrders: string[];

  showIdgMenu = false;
  modalData = {};
  idgUserId = 0;
  meetingId = 0;
  patChartId = 0;
  patientData = {};
  editIDGDiscussionNote = false;
  idgDiscussionComment = {};
  includeAmendHospiceCoverage = false;
  ePrescribeEnabled = false;
  showConvertToOrder = false;
  showReadBackdAndVerified = false;
  cancelLOCOptions: Partial<VoidLOCOptions>;
  patientStatus: string;
  patientDischargedDateTime: string;

  get optionMenuNameDiscontinued(): string {
    return this.order.discontinuedAction?.approvalType ===
      Order.ApprovalTypeEnum.Pending
      ? "Proceed with Discontinuation"
      : "Discontinue";
  }

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    public viewCtrl: ViewController,
    private alertCtrl: AlertController,
    public modalCtrl: ModalController,
    private navBarService: NavBarServiceProvider,
    private dataService: DocManagementDataService,
    private orderManagementDataService: OrderManagementDataService,
    private toastCtrl: ToastController,
    private documentSvc: DocManagementDataService,
    private reportExecutionService: ReportExecutionService,
    public loadingCtrl: LoadingController,
    private authSvc: AuthService,
    private stateData: StateManagementService
  ) {
    this.deleteButtonNameInList =
      this.navParams.data.deleteLabel &&
      this.navParams.data.deleteLabel == "Remove"
        ? "Remove"
        : "Delete";
    this.editAccess = this.navParams.data.editAccess;
    this.patientId = this.navParams.data.patientId;
    this.hideAdd = !!this.navParams.data.hideAdd;
    this.hideEdit = !!this.navParams.data.hideEdit;
    this.hideDeleteIcon = !!this.navParams.data.hideDelete;
    this.hideHistory = !!this.navParams.data.hideHistory;
    this.hideOrderManagment = !!this.navParams.data.hideOrderManagment;
    this.hideAllOrderManagment = !!this.navParams.data.hideAllOrderManagment;
    this.onlyDelete = !!this.navParams.data.onlyDelete;
    this.showHistory = !!this.navParams.data.showHistory;
    this.showButtonsAsList = !!this.navParams.data.showButtonsAsList;
    this.addButtonNameInList = this.navParams.data.addButtonNameInList
      ? this.navParams.data.addButtonNameInList
      : this.addButtonNameInList;
    this.editButtonNameInList = this.navParams.data.editButtonNameInList
      ? this.navParams.data.editButtonNameInList
      : this.editButtonNameInList;
    this.deleteButtonNameInList = this.navParams.data.deleteButtonNameInList
      ? this.navParams.data.deleteButtonNameInList
      : this.deleteButtonNameInList;
    this.disabledIcon = !!this.navParams.data.disabledIcon;
    this.disabledEdit = !!this.navParams.data.disabledEdit;
    this.disabledDelete = !!this.navParams.data.disabledDelete;
    this.order = this.navParams.data.order;
    this.showMedicationEdit = !!this.navParams.data.showMedicationEdit;
    this.isOrder = !!this.navParams.data.isOrder;
    this.userDisplayName = this.navParams.data.userDisplayName;
    this.isPalliative = !!this.navParams.data.isPalliative;
    this.showOrderManagement = !!this.navParams.data.showOrderManagement;

    this.cbMember = this.navParams.data.cbMember;
    this.cbMemberStatus = this.navParams.data.cbMemberStatus;

    this.accessLevel = this.navParams.data.accessLevel;
    this.historyLevel = this.navParams.data.historyLevel;
    this.page = this.navParams.data.page;
    this.type = this.navParams.data.type;
    this.isPatientChart = this.navParams.data.isPatientChart
      ? this.navParams.data.isPatientChart
      : false;
    this.isAdministrationEntry = this.navParams.data.isAdministrationEntry
      ? this.navParams.data.isAdministrationEntry
      : false;
    this.isNewCalendar = this.navParams.data.isNewCalendar
      ? this.navParams.data.isNewCalendar
      : false;
    this.deleteAccess = this.navParams.data.deleteAccess
      ? this.navParams.data.deleteAccess
      : false;
    this.showMarHeaderOptions = this.navParams.data.showMarHeaderOptions
      ? this.navParams.data.showMarHeaderOptions
      : false;
    this.showPrintMarButton = this.navParams.data.showPrintMarButton
      ? this.navParams.data.showPrintMarButton
      : false;
    this.showBenefitsButtonStrip = this.navParams.data.showBenefitsButtonStrip
      ? this.navParams.data.showBenefitsButtonStrip
      : false;
    this.orderPatientChartId = this.navParams.data.orderPatientChartId;
    this.orderId = this.navParams.data.orderId;
    this.orderTypeConfigurations = this.navParams.data.orderTypeConfigurations;
    this.orders = this.navParams.data.orders;
    this.orderType = this.navParams.data.orderType;
    this.disableCancelLOC = this.navParams.data.shouldDisableCancel;
    this.medicationSearchResults = this.navParams.data.medicationSearchResults;
    this.locOrders = this.navParams.data.locOrders;
    this.isPanelProvider = this.navParams.data.isPanelProvider;
    this.isAlreadySigned = this.navParams.data.isAlreadySigned;
    this.orderingProviderId = this.navParams.data.orderingProviderId;
    this.credentialedResource = this.navParams.data.credentialedResource;
    this.signatureRequest = this.navParams.data.signatureRequest;
    if (this.orderType == "LEVEL_OF_CARE") {
      this.setDiscontinuedOrders();
    }
    this.setAmendableOrders();
    this.stateData.showOrderEntryOM.subscribe((value) => {
      this.showConvertToOrder = value;
    });
    this.showIdgMenu = this.navParams.data.showIdgMenu;
    this.modalData = this.navParams.data.modalData;
    this.idgUserId = this.navParams.data.idgUserId;
    this.meetingId = this.navParams.data.meetingId;
    this.patChartId = this.navParams.data.patChartId;
    this.patientData = this.navParams.data.patientData;
    this.editIDGDiscussionNote = this.navParams.data.editIDGDiscussionNote;
    this.idgDiscussionComment = this.navParams.data.idgDiscussionComment;
    this.includeAmendHospiceCoverage = this.setIncludeAmendHospiceCoverage();
    this.includeAddEditMARDetails = this.setIncludeAddEditMARDetails();
    this.ePrescribeEnabled = this.navParams.data.ePrescribeEnabled;
    this.showReadBackdAndVerified = this.setIncludeAmendReadBackAndVerified();
    this.prepMARDetailsComponent();
    this.cancelLOCOptions = {
      discontinue: true,
    };
    this.patientStatus = this.navParams.data.patientStatus;
    this.patientDischargedDateTime =
      this.navParams.data.patientDischargedDateTime;
  }

  setIncludeAmendReadBackAndVerified(): boolean {
    return (
      Action.SignatureRequestEnum.Created === this.signatureRequest &&
      this.navParams.data.order &&
      this.navParams.data.order.orderType === "MEDICATION" &&
      (!this.navParams.data.order.hasOwnProperty("readBackAndVerified") ||
        this.navParams.data.order.readBackAndVerified === false) &&
      this.navParams.data.order.approvalType == Order.ApprovalTypeEnum.Verbal
    );
  }

  setIncludeAmendHospiceCoverage(): boolean {
    return (
      Action.SignatureRequestEnum.Created === this.signatureRequest &&
      this.orderTypeConfigurations &&
      this.navParams.data.includeAmendHospiceCoverage
    );
  }

  setIncludeAddEditMARDetails(): boolean {
    return (
      Action.SignatureRequestEnum.Created === this.signatureRequest &&
      this.navParams.data.order &&
      this.navParams.data.order.orderType === "MEDICATION"
    );
  }

  setAmendableOrders() {
    if (this.orderTypeConfigurations) {
      this.amendableOrders = this.orderTypeConfigurations
        .map((orderType) => {
          if (orderType.amendable) {
            return orderType.orderType;
          }
        })
        .filter((orderType) => orderType !== undefined);
    }
  }

  setDiscontinuedOrders() {
    if (!this.locOrders) {
      return; // Not yet loaded
    }
    this.discontinuedLocOrders = this.locOrders
      .filter(Order.isDiscontinued)
      .sort((a, b) => {
        const discontinueDate1 = new Date(a.discontinueDate);
        const discontinueDate2 = new Date(b.discontinueDate);
        return discontinueDate2.getTime() - discontinueDate1.getTime();
      });
  }

  checkClicked() {
    this.viewCtrl.dismiss({ checked: true });
  }

  createOrder() {
    this.viewCtrl.dismiss({ order: true });
  }

  editView() {
    this.viewCtrl.dismiss({ edit: true });
  }

  deleteView() {
    this.viewCtrl.dismiss({ delete: true });
  }

  discontinueView() {
    this.viewCtrl.dismiss({ discontinue: true });
  }

  deleteEvent() {
    if (this.isPatientChart === false) this.viewCtrl.dismiss({ delete: true });
    else {
      let pageName = "Selected Details";
      switch (this.page) {
        case "AddPatientDetailsPopoverPage":
          pageName = "Patient Details";
          break;
        case "LevelOfCarePopoverPage":
          pageName = "Level of Care";
          break;
        case "AwareOfReferralPage":
          pageName = "Aware of Referral Details";
          break;
        case "HospiceTransferPage":
          pageName = "Hospice Transfer Details";
          break;
        case "FuneralHomePharmacyPage":
          pageName =
            this.type === "Pharmacy"
              ? "Pharmacy Details"
              : "Funeral Home Details";
          break;
        case "CallerPopoverPage":
          pageName = "Caller Details";
          break;
        case "ReferrerPage":
          pageName = "Referrer Details";
          break;
        case "ReferringPhysicianPage":
          pageName =
            this.type === "Referring Physician"
              ? "Referring Physician Details"
              : "Ordering Physician Details";
          break;
        case "PhysiciansOrderPage":
          pageName = "Physician's Order Details";
          break;
        case "ReferralsCreditPage":
          pageName = "Referral Credit Details";
          break;
        case "DiagnosisHistoryPage":
          pageName = "Diagnosis";
          break;
        case "PatientHistoryGridComponent":
          pageName = "Patient History record";
          break;
        case "IDGMeetingPage":
          pageName = "this Discussion Note";
          break;
      }
      if (this.page !== "MedsDmeDeleteConfirmationPage") {
        let alert = this.alertCtrl.create({
          title: "Delete Confirmation",
          message: `Are you sure you want to remove ${pageName}?`,
          cssClass: "duplicate-patient",
          buttons: [
            {
              text: "Cancel",
              role: "cancel",
              handler: () => {
                this.viewCtrl.dismiss({});
              },
            },
            {
              text: "Ok",
              handler: () => {
                this.viewCtrl.dismiss({ delete: true });
              },
            },
          ],
        });
        alert.present();
      } else {
        this.viewCtrl.dismiss({ delete: true });
      }
    }
  }

  printEvent() {
    window.print();
  }

  historyView() {
    this.viewCtrl.dismiss({ showHistory: true });
  }

  addEvent() {
    this.viewCtrl.dismiss({ add: true });
  }

  deleteEventWithoutConfirmation() {
    this.viewCtrl.dismiss({ delete: true });
  }

  printMarReport() {
    this.viewCtrl.dismiss({ print: true });
  }

  changeCbMemberStatus() {
    this.viewCtrl.dismiss({ cbMemberStatus: true });
  }

  convertToOrder() {
    this.viewCtrl.dismiss({ convertToOrder: true });
  }

  convertToErx() {
    this.viewCtrl.dismiss({ convertToErx: true });
  }

  get disableDiscontinuedOption() {
    // You can always discontinue an order if the discontinue is pending
    if (
      this.order.discontinuedAction?.approvalType ===
      Order.ApprovalTypeEnum.Pending
    ) {
      return false;
    }

    const dcDate =
      this.order.discontinuedAction?.discontinueDate ??
      this.order.discontinueDate;
    if (!dcDate) {
      return false;
    }
    return (
      moment.utc(dcDate).format("YYYY-MM-DDThh:mm:ssZ") <=
      moment().format("YYYY-MM-DDThh:mm:ssZ")
    );
  }

  get hideAmendedOrder() {
    return this.amendableOrders.includes(this.order.orderType);
  }

  get showDiscontinueOption() {
    if (Action.SignatureRequestEnum.Discontinued === this.signatureRequest) {
      return false;
    }
    if (this.patientIsDischarged()) {
      return "DIAGNOSIS" !== this.order.orderType;
    }
    return !["LEVEL_OF_CARE", "DIAGNOSIS"].includes(this.order.orderType);
  }

  patientIsDischarged() {
    return this.patientStatus === "discharge";
  }

  get includeCancelLOCOption() {
    return (
      this.order.orderType == "LEVEL_OF_CARE" &&
      this.locOrders != null &&
      !this.order.discontinuedAction
    );
  }

  discontinueOrder() {
    const { orderType, orderSubtype } = this.order;
    if (
      orderType == "MEDICATION" &&
      orderSubtype == "ERX" &&
      this.ePrescribeEnabled &&
      this.order.discontinuedAction?.approvalType !==
        Order.ApprovalTypeEnum.Pending // Discontinue Orders from ScriptSure begin as pending and they must "proceed" Curantis
    ) {
      this.viewCtrl.dismiss({ showEprescribeIframe: true });
    } else {
      let popover = this.modalCtrl.create(
        DiscontinueOrder,
        {
          orderTypeConfigurations: this.orderTypeConfigurations,
          order: this.order,
          userDisplayName: this.userDisplayName,
          credentialedResource: this.credentialedResource,
          isDischargedPatient: this.patientIsDischarged(),
          dischargedDatetime: this.patientDischargedDateTime,
        },
        { cssClass: "popup-medium" }
      );

      popover.present({
        //ev: $event
      });
      popover.onDidDismiss((mode) => {
        this.viewCtrl.dismiss({ discontinue: true });
      });
    }
  }

  setLastLOCOrderId(): string | 0 {
    return this.discontinuedLocOrders.length > 0
      ? this.discontinuedLocOrders[0].orderId
      : 0;
  }

  cancelLOCOrder() {
    let popover = this.modalCtrl.create(
      CancelOrder,
      {
        order: this.order,
        lastLOCOrderId: this.setLastLOCOrderId(),
        userDisplayName: this.userDisplayName,
      },
      { cssClass: "popup-medium" }
    );

    popover.present({
      // ev: $event
    });

    popover.onDidDismiss((mode) => {
      const lastLOCOrderId = this.setLastLOCOrderId();
      if (!mode?.userCanceledOutOfModal) {
        this.cancelLOCOptions.openAddOrderModal = lastLOCOrderId === 0;
      }
      this.viewCtrl.dismiss(this.cancelLOCOptions);
    });
  }

  getAmendRequest = (data?: Partial<AmendedAction>) => {
    let amendedOrder$: Observable<OrderResponse> | undefined;
    if (data) {
      amendedOrder$ = this.orderManagementDataService.updateOrder(
        this.order.orderId,
        {
          actionType: Action.ActionTypeEnum.Amended,
          displayName: this.userDisplayName,
          timezone: moment.tz.guess(),
          ...data,
        }
      );
    }
    this.viewCtrl.dismiss({ amendedOrder$ });
  };

  prepMARDetailsComponent() {
    if (this.orderTypeConfigurations) {
      this.getMARDetailsOrderTypeConfigurations();
      if (
        this.marDetailsComponentProperties &&
        this.marDetailsComponentProperties.length > 0
      )
        this.marDetailsComponentPropertiesIsEmpty = false;
    } else {
      this.marDetailsComponentPropertiesIsEmpty = true;
    }
  }

  getMARDetailsOrderTypeConfigurations() {
    const medOrderTypeConfig = this.orderTypeConfigurations.find(
      (orderTypeConfiguration) =>
        orderTypeConfiguration.orderType === "MEDICATION"
    );
    const marDetailsComponentConfig = medOrderTypeConfig.components?.find(
      (components) => components.componentName === "mar-details"
    );
    this.marDetailsComponentProperties =
      marDetailsComponentConfig?.properties.map((property) => property);
  }

  editHospiceCoverageData() {
    let editHospiceCoverageDataModal = this.modalCtrl.create(
      EditHospiceCoverage,
      {
        orderTypeConfigurations: this.orderTypeConfigurations,
        patientId: this.navBarService.externalId,
        patientChartId: this.orderPatientChartId,
        orders: this.orders,
        order: this.order,
        formType: "amendment",
        locOrders: this.locOrders,
      },
      {
        enableBackdropDismiss: false,
        cssClass: "edit-hospice-coverage-modal",
      }
    );
    editHospiceCoverageDataModal.onDidDismiss(this.getAmendRequest);
    editHospiceCoverageDataModal.present();
  }

  addEditMARDetails() {
    let addEditMARDetailsDataModal = this.modalCtrl.create(
      AddEditMARDetails,
      {
        componentProperties: this.marDetailsComponentProperties,
        patientId: this.navBarService.externalId,
        patientChartId: this.orderPatientChartId,
        order: this.order,
        userDisplayName: this.userDisplayName,
      },
      {
        enableBackdropDismiss: false,
        cssClass: "add-edit-mar-details",
      }
    );
    addEditMARDetailsDataModal.present();
    addEditMARDetailsDataModal.onDidDismiss((mode) => {
      this.viewCtrl.dismiss({ discontinue: true });
    });
  }

  amendOrder() {
    let addOrderModal = this.modalCtrl.create(
      AddOrder,
      {
        orderTypeConfigurations: this.orderTypeConfigurations,
        patientId: this.navBarService.externalId,
        patientChartId: this.orderPatientChartId,
        orders: this.orders,
        order: this.order,
        formType: "amendment",
        locOrders: this.locOrders,
      },
      { enableBackdropDismiss: false, cssClass: "add-order-modal" }
    );
    addOrderModal.onDidDismiss(this.getAmendRequest);
    addOrderModal.present();
  }

  printOrder() {
    this.reportExecutionService.downloadReport(
      "patient_order_detail_report",
      this.buildReportPayload(),
      this.reportExecutionService.buildReportFilename(
        "patient_order_detail_report",
        "pdf"
      )
    );
    this.orderManagementDataService
      .bulkUpdateOrders(
        Utils.createTrackOrdersPayload(
          [{ orderId: this.order.orderId.toString(), medicationId: "" }],
          Action.ActionTypeEnum.Printed,
          moment.tz.guess(),
          this.userDisplayName
        )
      )
      .subscribe(
        () => {},
        () => {}
      );
  }

  buildReportPayload() {
    const orgId = this.authSvc.getUser().tenantId;
    // const orgId = this.authSvc.getUserOrganization();
    const orderId = this.order.orderId;
    let payload = {
      pPatientChartID: this.navBarService.externalId.toString(),
      pOrgID: orgId.toString(),
      pOrderID: orderId,
      pOrderStatus: this.signatureRequest
        .charAt(0)
        .toUpperCase()
        .concat(this.signatureRequest.slice(1)),
    };
    return payload;
  }

  addNotes(event) {
    let modal = this.modalCtrl.create(
      AddNotesPopup,
      {
        addNoteOrders: [this.orderId],
        userDisplayName: this.userDisplayName,
      },
      {
        enableBackdropDismiss: false,
        cssClass: "add-order-modal",
      }
    );
    modal.present({
      ev: event,
    });
    modal.onDidDismiss((x) => {
      let $errors = [];
      this.viewCtrl.dismiss({ $errors, shouldReload: x["shouldReload"] });
    });
  }

  selectFile(e) {
    for (const element of e.target.files) {
      this.listFiles.push(element);
    }
    this.uploadFile();
  }

  async uploadFile() {
    await Promise.all(
      this.listFiles.map(async (file, index) => {
        let payload = {
          key: this.hideAllOrderManagment
            ? this.orderPatientChartId
            : this.navBarService.getExternalId(),
          label: Utils.getFileName(file.name),
          serviceName: "PatientChart",
          fileExtension: file.name.slice(file.name.lastIndexOf(".")),
          description: "Order File",
          category: "Provider Orders",
          patientID: this.hideAllOrderManagment
            ? this.orderPatientChartId
            : this.navBarService.getExternalId(),
        };
        let body = new FormData();
        body.append("file", file);
        body.append("tags", JSON.stringify(payload));
        this.dataService.uploadDocument(body).subscribe(
          (data) => {
            this.idFiles.push(data["documentId"].toString());
            if (this.idFiles.length == this.listFiles.length) {
              let orderPatch: OrderPatchRequest = {
                actionType: Action.ActionTypeEnum.DocumentUploaded,
                displayName: this.userDisplayName,
                timezone: moment.tz.guess(),
                documentIds: this.idFiles,
              };
              this.patchOrder(orderPatch);
            }
          },
          (err) => {
            console.error(err.error);
            this.viewCtrl.dismiss({});
          }
        );
      })
    );
  }

  patchOrder(orderPatchRequest: Partial<OrderPatchRequest>): void {
    const updateFile$ = this.orderManagementDataService.updateOrder(
      this.order.orderId,
      orderPatchRequest
    );
    this.viewCtrl.dismiss({ updateFile$ });
  }

  printDocument(id) {
    try {
      this.increaseSpinnerCount("Loading File...");
      this.documentSvc.getDocumentToView(id).subscribe(
        (data) => {
          const file = new Blob([data], { type: "application/pdf" });
          const fileURL = URL.createObjectURL(file);
          window.open(fileURL, "_blank");
          this.decreaseSpinnerCount();
          this.viewCtrl.dismiss({});
        },
        (err) => {
          this.decreaseSpinnerCount();
          console.log("entered error", err);
        }
      );
    } catch (error) {
      console.log("Error during data submission and building.", error);
    }
  }

  increaseSpinnerCount(message: string) {
    this.spinnerCounter++;
    if (this.spinnerCounter && this.spinner == null) {
      this.spinner = this.loadingCtrl.create({
        content: message,
      });
      this.spinner.present();
    }
  }

  decreaseSpinnerCount() {
    this.spinnerCounter--;
    if (this.spinnerCounter <= 0) {
      this.spinner.dismiss();
      this.spinner = null;
    }
  }

  disableAmmend() {
    return (
      (this.order.orderType === "LEVEL_OF_CARE" && this.order.canceledAction) ||
      this.order.discontinuedAction
    );
  }

  eSign(event) {
    let modal = this.modalCtrl.create(
      ESignOrder,
      {
        orderId: this.orderId,
        userDisplayName: this.userDisplayName,
        signatureRequest: this.signatureRequest,
      },
      {
        enableBackdropDismiss: false,
      }
    );
    modal.present({
      ev: event,
    });
    modal.onDidDismiss((x) => {
      this.viewCtrl.dismiss({ shouldReload: x["shouldReload"] });
    });
  }

  rejectOrder() {
    let modal = this.modalCtrl.create(
      RejectOrder,
      {
        name: this.order.nameDescription,
        orderId: this.orderId,
        userDisplayName: this.userDisplayName,
        orderingProviderId: this.orderingProviderId,
        signatureRequest: this.signatureRequest,
      },
      {
        enableBackdropDismiss: false,
      }
    );
    modal.present({
      ev: event,
    });
    modal.onDidDismiss((x) => {
      this.viewCtrl.dismiss({ shouldReload: x["shouldReload"] });
    });
  }

  uploadDocument() {
    let modal = this.modalCtrl.create(
      UploadOrderDocumentsPopover,
      {
        order: this.order,
        userDisplayName: this.userDisplayName,
        hideAllOrderManagment: true,
        orderPatientChartId: this.orderPatientChartId,
        signatureRequest: this.signatureRequest,
      },
      {
        enableBackdropDismiss: false,
        cssClass: "popup-small",
      }
    );
    modal.present({
      ev: event,
    });
    modal.onDidDismiss((mode) => {
      this.viewCtrl.dismiss(mode);
    });
  }

  showEditDiscussionNotes(event) {
    let modal = this.modalCtrl.create(
      CreateCommentModalPage,
      {
        modalData: this.modalData,
        idgUserId: this.idgUserId,
        meetingId: this.meetingId,
        patChartId: this.patChartId,
        patientData: this.patientData,
        editIDGDiscussionNote: this.editIDGDiscussionNote,
        idgDiscussionComment: this.idgDiscussionComment,
      },
      {
        enableBackdropDismiss: false,
      }
    );
    modal.present({
      ev: event,
    });
    modal.onDidDismiss((mode) => {
      this.viewCtrl.dismiss(mode);
    });
  }

  editReadBackAndVerified() {
    let readBackAndVerifiedModal = this.modalCtrl.create(
      ReadBackAndVerified,
      {
        order: this.order,
      },
      {
        enableBackdropDismiss: false,
        cssClass: "edit-hospice-coverage-modal",
      }
    );
    readBackAndVerifiedModal.onDidDismiss(this.getAmendRequest);
    readBackAndVerifiedModal.present();
  }
}



// WEBPACK FOOTER //
// ./src/navigation/components/edit-view-popover/edit-view-popover.ts